import { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import { Link, useHistory } from 'react-router-dom';
import { getAwsp, updateAwsp } from '../../utils/functions';
import Footer from '../../components/Footer/Footer';
import React from 'react';

function AWSPEdit(props) {
    const history = useHistory();

    const [cell, setCell] = useState();
    const [AWSPOption, setAWSPOption] = useState([]);
    useEffect(() => {
        const getAndSetCell = async () => {
            const response = await getAwsp(props.match.params.schoolId, props.match.params.cellId);
            setCell(response);
            if (response.awsp) {
                setAWSPOption(response.awsp);
            }
        };

        Promise.all([getAndSetCell()]);
    }, []);

    const possibleAWSPCategories = [
        'Creating a Culture',
        'Ensuring School Safety',
        'Planning with Data',
        'Aligning Curriculum',
        'Improving Instruction',
        'Managing Resources',
        'Engaging Families & Communities',
        'Closing the Gap',
    ];

    const onChangeAWSPOption = (e, value) => {
        if (e.target.checked) {
            if (!AWSPOption.includes(value)) {
                setAWSPOption([...AWSPOption, value]);
            }
        } else {
            setAWSPOption(AWSPOption.filter((opt) => opt !== value));
        }
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (AWSPOption) {
            await updateAwsp(props.match.params.schoolId, props.match.params.cellId, AWSPOption);

            history.push(`/isslc/${props.match.params.schoolId}`);
        }
    };

    return (
        <>
            <Header title={`AWSP - ${cell?.row_id?.name}`} />

            <main className={'edit-container container'}>
                <div className={'edit-form-info'}>
                    <h3>
                        <Link to={'/'}>Dashboard</Link>
                    </h3>
                    <h3>
                        <Link to={'/CSIP'}>Schools</Link>
                    </h3>
                </div>
                <div className={'edit-form-info'}>
                    <h3>
                        <Link to={'/'}>Dashboard</Link>
                    </h3>
                    <h3>
                        <Link to={'/ISSLC'}>Schools</Link>
                    </h3>
                    <h3>
                        <Link to={`/ISSLC/${props.match.params.schoolId}`}> {cell?.row_id?.name} </Link>
                    </h3>
                </div>

                <form
                    className={'edit-form'}
                    onSubmit={(e) => {
                        onSubmit(e);
                    }}
                >
                    <div className={'form-section'}>
                        <div className={'flex-2'}>
                            <div className={'flex-column'}>
                                <h4 className={'label'}>Select AWSP criteria below</h4>
                                {possibleAWSPCategories.map((option, index) => {
                                    return (
                                        <>
                                            <label>
                                                <input
                                                    key={index}
                                                    type={'checkbox'}
                                                    checked={AWSPOption.includes(option)}
                                                    onChange={(e) => onChangeAWSPOption(e, option)}
                                                />
                                                {option}
                                            </label>
                                        </>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    <div className={'form-section'}>
                        <button type={'submit'}>Save</button>
                    </div>
                </form>
            </main>

            <Footer />
        </>
    );
}

export default AWSPEdit;
